import i18n from '../i18n';

const config = {
  // Stripe publishable key. In production set VITE_STRIPE_PUBLISHABLE_KEY at build
  // time; locally Vite reads it from packages/frontend/.env.local.
  stripe_pk: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
  loggerBaseString: 'dashboard-react',
  supportedLanguages: ['de', 'en'],
  extensionIdChrome: localStorage.getItem('dev-extension') || 'hegppmjkecopkbicfkecnlemdincdnfj',
  extensionChromeStoreURL: 'https://chrome.google.com/webstore/detail/secret-ai-agent/hegppmjkecopkbicfkecnlemdincdnfj?hl=de',
  extensionIdEdge: localStorage.getItem('dev-extension') || 'mjibalopcdabokfdbnbngbimajfbpmii',
  extensionEdgeStoreURL: 'https://microsoftedge.microsoft.com/addons/detail/secret-ai-agent/mjibalopcdabokfdbnbngbimajfbpmii',
  outlookAddInStoreURL: 'https://appsource.microsoft.com/en-us/product/office/WA200003521?src=office',
  textGenBlacklist: ['siemens'],
  textGenWhitelist: [
    'carolin.barry@siemens.com',
    'mike.demarest@siemens.com',
    'charis.endres@siemens.com',
    'victoria.peach@siemens.com',
    'jenifer.tringola@siemens.com',
    'maria.gaugler-penn@siemens.com',
    'wendy.kowal@siemens.com',
    'heather.hynes@siemens.com',
    'jessica.bromhorst@siemens.com',
    'emal.abdulsamed@siemens.com',
    'david-alexandre.gava@siemens.com',
    'will.melanie@siemens.com',
    'ana.morato_cubillo@siemens.com',
    'lucia.barahona-davila.ext@siemens.com',
    'catarina.rodrigues-martins@siemens.com',
    'carolina.raposo@siemens.com',
    'rita.rola@siemens.com',
    'elisa.batista@siemens.com',
    'fernanda.pinheiro.ext@siemens.com',
    'larissa.jabbour@siemens.com',
    'david.villamil-suaste@siemens.com',
    'mariana.cordero-rebollo@siemens.com',
    'adriana.lima@siemens.com',
    'syed.imtiaz@siemens.com',
    'yasmeen.elsayed@siemens.com',
    'heba.abotaleb@siemens.com',
    'marta.brockwell@siemens.com',
    'julia.oldenburg@siemens.com',
    'chloe.renaud@siemens.com',
    'ariane.lekare@siemens.com',
    'gabriel.verdugo@siemens.com',
    // Siemens AG Nürnberg
    'aylin.elguen@siemens.com',
    'hannah.tretinjak@siemens.com',
    'katrin.bongartz@siemens.com',
    'diana.falke@siemens.com',
    'anja.kreuzer@siemens.com',
    'nathalie.jellen@siemens.com',
    'evelyne.dorn@siemens.com',
    'helga.doehn@siemens.com',
    'julia.sierla-donczyk@siemens.com',
    'lukas.distler@siemens.com',
    // 04.08.23
    'myriam.koppers@siemens-logistics.com',
    'anna.meyer@siemens-logistics.com',
    // 06.10.23
    'aylin.elguen@siemens.com',
    'aleksandra.domracheva@siemens.com',
    'julia.sierla-donczyk@siemens.com',
    'helga.doehn@siemens.com',
    'nathalie.jellen@siemens.com',
    'lukas.distler@siemens.com',
    'katrin.bongartz@siemens.com',
    'bianca.thoma@siemens.com',
    'diana.falke@siemens.com',
    'hannah.tretinjak@siemens.com'
  ],
  contactManagementWhitelist: ['michael.schwab@bonago.de', 'tanja_brenner@gmx.de', 'hj.hunger@proselcon.de', '@tiba.de'],
  textGenerationLanguages: [
    { key: 'auto-detect', text: i18n.t('autoDetect') },
    { key: 'de', text: i18n.t('german') },
    { key: 'en', text: i18n.t('english') },
    { key: 'it', text: i18n.t('italian') },
    { key: 'fr', text: i18n.t('french') },
    { key: 'es', text: i18n.t('spanish') },
    { key: 'pt', text: i18n.t('portuguese') },
    { key: 'nl', text: i18n.t('dutch') },
  ],
  augmentedWriting: {
    customer: {
      supportedLanguagesTextGeneration: ['en'],
      scores: {
        jointPosAchieve: {
          composed: ['posAchieve', 'negAchieve', 'achieve'],
          chart: {
            show: true,
            color: '#FEF25C',
            label: i18n.t('chartLabelAchieve'),
          },
          explanation: i18n.t('explanationJointPosAchieve'),
        },
        jointPosAffil: {
          composed: ['posAffil', 'negAffil', 'affil'],
          chart: {
            show: true,
            color: '#74D883',
            label: i18n.t('chartLabelAffil'),
          },
          explanation: i18n.t('explanationJointPosAffil'),
        },
        jointPosPower: {
          composed: ['posPower', 'negPower', 'power'],
          chart: {
            show: true,
            color: '#FF9598',
            label: i18n.t('chartLabelPower'),
          },
          explanation: i18n.t('explanationJointPosPower'),
        },
        regFocus: {
          composed: ['DAV', 'adjective', 'reward', 'risk', 'posEmo', 'negEmo'],
          chart: {
            show: true,
            color: '#A2FFED',
            label: i18n.t('chartLabelOrientation', { interpolation: { escapeValue: false } }),
          },
          explanation: i18n.t('explanationOrientation'),
        },
        authenticity: {
          composed: ['relativ', 'we', 'adverb', 'discrep'],
          chart: {
            show: false,
            color: '#FFCD75',
            label: i18n.t('degreeOfFormality'),
          },
          explanation: i18n.t('explanationAuthenticity'),
        },
        diversity: {
          composed: ['masculine', 'feminine'],
          chart: {
            show: false,
            color: '#F5A9F2',
            label: i18n.t('chartLabelGender'),
          },
          explanation: i18n.t('explanationGender'),
        },
      },
      profileMapping: {
        jointPosAffil: [i18n.t('lowComparison'), '', '', '', i18n.t('dominantComparison')],
        jointPosAchieve: [i18n.t('lowComparison'), '', '', '', i18n.t('dominantComparison')],
        jointPosPower: [i18n.t('lowComparison'), '', '', '', i18n.t('dominantComparison')],
        authenticity: [i18n.t('formal'), '', '', '', i18n.t('informal')],
        regFocus: [i18n.t('lowComparison'), '', '', '', i18n.t('moreComparison')],
      },
    },
  },
  textGenres: [
    { key: 'websiteText', name: i18n.t('websiteText') },
    { key: 'emails', name: i18n.t('emailOrLinkedin') },
    { key: 'blogpost', name: i18n.t('blogpost') },
    { key: 'jobOffers', name: i18n.t('jobOffer') },
    { key: 'ecommerce', name: i18n.t('ecommerce') },
  ],
  /**
   * This is the current time of the update in milliseconds
   * You can get the current time in milliseconds from the website:
   * https://currentmillis.com/
   */
  changeTime: 1601282537985,
  overallAvgRq: 68.78,
  errorBoundryMessages: {
    profileSelection: 'Try to reload the page.',
    augmentedWriter: 'Maybe your text includes bad formatting. Please try to paste the text with as little formatting as possible.',
    profileSelected: 'Try to use another profile.',
  },
};

export default config;
